import { createContext, useContext } from 'react';
import { ResourceType } from '@cotera/api';

export type OpenResourceArtifactOptions = {
  /** Display name, used by payloads that carry one (folders). */
  name?: string;
  /** Merged over the type's default artifact payload, e.g. `{ isNew: true }`. */
  payload?: Record<string, unknown>;
};

export type ResourceArtifactPanelContextValue = {
  /** Open a resource in the side panel (replaces any currently-open artifact). */
  openResourceArtifact: (
    resourceType: ResourceType,
    resourceId: string,
    options?: OpenResourceArtifactOptions
  ) => void;
  /** Close the panel (clears the open artifact). */
  closeArtifact: () => void;
};

export const ResourceArtifactPanelContext =
  createContext<ResourceArtifactPanelContextValue | null>(null);

/**
 * Available only inside a `ResourceArtifactPanelProvider` (i.e. a standalone
 * editor page in `mode='page'`). Returns `null` elsewhere — callers should fall
 * back to navigation when there's no panel to open.
 *
 * Lives apart from the provider component so consumers can read the context
 * without pulling in `ArtifactSidePanel`, which mounts the navigator bridge that
 * reads this hook.
 */
export const useResourceArtifactPanel =
  (): ResourceArtifactPanelContextValue | null =>
    useContext(ResourceArtifactPanelContext);
